
import React from 'react';
import ImageGallery from 'react-image-gallery';
import Prismic from 'prismic-javascript'
import { Date, Link, RichText } from 'prismic-reactjs'

const apiEndpoint = 'https://brigit-aklin.cdn.prismic.io/api/v2'
const accessToken = '' // This is where you would add your access token for a Private repository
 
const client = Prismic.client(apiEndpoint)

const images = [
  {
    original: 'images_neu/24_SchmuckForum_S1-033.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-084.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-106.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-131.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-118.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-023.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-122.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-126.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-050.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-046.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-086.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-089.jpg',
  },  
  {
    original: 'images_neu/24_SchmuckForum_S1-111.jpg',
  },
  {
    original: 'images_neu/24_SchmuckForum_S1-114.jpg',
  },
  {
    original: 'images_alt/bild1.gif',
  },  
  {
    original: 'images_alt/bild2.gif',
  },  
  {
    original: 'images_alt/bild3.gif',
  },  
  {
    original: 'images_alt/bild4.gif',
  },  
  {
    original: 'images_alt/bild7.gif',
  },
  {
    original: 'images_alt/image1.gif',
  },
];

class Gallery extends React.Component {
  render() {
    return (
      <div id="gallery">
        <ImageGallery 
          items={images} 
          slideInterval={50000} 
          showThumbnails={false} 
          showPlayButton={false} 
          autoPlay 
          slideDuration={700}
          sizes={"80vh"}
          />
      </div>
    );
  }
}

class Footer extends React.Component {
  render() {
    return (
      <div id="footerView" style={{margin: 50}}>
        <div style={{textAlign: 'center', width: '100%'}}> 
          © 2026 BY BRIGIT AKLIN
        </div>
      </div>
    );
  }
}

class Contact extends React.Component {

  state = {
    hours: null
  }

  async componentDidMount() {
    const response = await client.query(
      Prismic.Predicates.at('document.type', 'hours')
    )
    this.setState({'hours': response && response.results && response.results[0]});
  }

  renderOpeningHoursLeft() {
    if(!this.state.hours) return null;
    return RichText.render(this.state.hours.data.left)
  }

  renderOpeningHoursRight() {
    if(!this.state.hours) return null;
    return RichText.render(this.state.hours.data.right)
  }

  render() {
    console.log(this.state);
    return (
      <div id="contactView">
        <div style={{textAlign: 'center'}}>
          <br />
          <h2 style={{marginTop: 10, marginBottom: 20, fontWeight: 'bold'}}>Kontakt & Öffnungszeiten</h2>
        </div>
        <br />
        <br />
        <div style={{display: 'flex'}}>
          <div style={{flex: 5}}></div>
          <div style={{padding: 20}}>
              <p><b>Kontakt</b></p>
              <p>Brigit Aklin</p>
              <p><a href="mailto:brigit.aklin@icloud.com" target="_blank">brigit.aklin@icloud.com</a><br/></p>
              <p><a href="https://www.instagram.com/schmuckforum" target="_blank">Instagram</a><br/></p>
              <p>+41 77 418 18 60</p>
          </div>
          <div style={{flex: 1}}></div>
          <div style={{padding: 20}}>
            <p><b>Adresse</b></p>
            <p> 
              <a href="http://www.schmuckforum.ch" target="_blank">Schmuckforum</a>
            </p>
              <p>Zollikerstrasse 12</p>
              <p>8008 Zürich</p>
          </div>
          <div style={{flex: 1}}></div>
          <div style={{padding: 20}}>
            <p><b>Öffnungszeiten</b></p>
            {this.renderOpeningHoursLeft()}

          </div>
          <div style={{flex: 5}}></div>
        </div>
        <br />

        <div style={{textAlign: 'center', marginTop: 40}}>
          <iframe 
            style={{width: '90%', height: '400px'}} 
            id="gmap_canvas" 
            src="https://maps.google.com/maps?q=schmuckforum&t=&z=15&ie=UTF8&iwloc=&output=embed" 
            frameBorder="0" 
            scrolling="no" 
            marginHeight="0" 
            marginWidth="0"></iframe>
        </div>
      </div>
    );
  }
}

class App extends React.Component {

  state = {
    hours: null
  }

  async componentDidMount() {
    const response = await client.query(
      Prismic.Predicates.at('document.type', 'hours')
    )
    this.setState({'hours': response && response.results && response.results[0]});
  }

  renderOpeningHoursLeft() {
    if(!this.state.hours) return null;
    return RichText.render(this.state.hours.data.left)
  }

  renderOpeningHoursRight() {
    if(!this.state.hours) return null;
    return RichText.render(this.state.hours.data.right)
  }

  render() {
    return (
      <div>
        <div id="helloView" style={{
          height: '100vh', 
          backgroundColor: '#222222', // #282c34', 
          textAlign: 'center', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <span>
            <h1 style={{color: 'white'}}>BRIGIT AKLIN</h1> 
            <h4 style={{color: 'white', marginTop: 50}}>GOLDSCHMIEDIN, SCHMUCKFORUM ZÜRICH</h4>
          </span>


          <a href="#" style={{position: 'absolute', bottom: '0vh'}} onClick={(e) => {
            e.preventDefault();
            document.querySelector('#gallery').scrollIntoView({ behavior: 'smooth' });
          }}><img src="assets/chevron-down.svg" style={{width: 100, color: 'white', filter: 'invert(1)'}}/></a>
        
        </div>
        <div style={{
          height: '0vh',
          backgroundColor: '#222222',
          textAlign: 'center'
        }}>
        </div>
        <div id="gallery-container">
          <Gallery />
          <a href="#" style={{position: "absolute", bottom: '0vh'}} onClick={(e) => {
            e.preventDefault();
            document.querySelector('#contactView').scrollIntoView({ behavior: 'smooth' });
          }}><img src="assets/chevron-down.svg" style={{width: 100, marginLeft: -50, color: 'white', filter: 'invert(1)'}}/></a>
        </div>
        <Contact />
        <Footer />
      </div>
    );
  }
}
export default App;
